import { guidEmpty } from "../../../../utils/guid-empty";
import { EnumRegime } from "../../../enums";
import { ConfigEmpresaModel } from "./config-empresa-model";

export class EmpresaCompletaModel {
    constructor(
        public id: string = guidEmpty(),
        public cpfcnpj: string = '',
        public ierg: string = '',
        public im: string = '',
        public razaoSocial: string = '',
        public nomeFantasia: string = '',
        public dNascimento: string | undefined | Date = undefined,
        public cnae: string = '',
        public regime: EnumRegime = EnumRegime.NAOSEAPLICA,
        public fone: string = '',
        public site: string = '',
        public infAdic: string = '',
        public cep: string = '',
        public logradouro: string = '',
        public numero: string = '',
        public complemento: string = '',
        public bairro: string = '',
        public municipio: string = '',
        public cMunicipio: string = '',
        public longitude: number = 0,
        public latitude: number = 0,
        public uf: string = '',
        public segmento: string = '',
        public segmentoId: string = guidEmpty(),
        public email: string = '',
        public configuracoes: ConfigEmpresaModel[] = [new ConfigEmpresaModel()],
    ) { }
}

